import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M19.57 22.528a1.5 1.5 0 0 0 .43-1.051v-2.825a3.5 3.5 0 0 0 2.816-3.125C22.939 14.149 23 12.64 23 11c0-1.321-.04-2.48-.12-3.475a3.5 3.5 0 0 0-3.239-3.211C16.718 4.104 14.182 4 12.032 4c-2.155 0-4.712.105-7.672.315a3.5 3.5 0 0 0-3.24 3.212C1.04 8.522 1 9.68 1 11c0 1.637.061 3.144.184 4.522a3.5 3.5 0 0 0 3.235 3.18 106.71 106.71 0 0 0 9.388.266l3.641 3.578a1.5 1.5 0 0 0 2.122-.018Zm-.106-4.814a.5.5 0 0 0-.464.498v3.265a.5.5 0 0 1-.85.356l-3.792-3.726a.5.5 0 0 0-.36-.143 105.706 105.706 0 0 1-9.508-.259 2.5 2.5 0 0 1-2.31-2.272A50.29 50.29 0 0 1 2 11c0-1.295.039-2.426.116-3.393a2.5 2.5 0 0 1 2.315-2.294C7.37 5.104 9.903 5 12.032 5c2.124 0 4.637.104 7.538.311a2.5 2.5 0 0 1 2.313 2.294c.078.967.117 2.1.117 3.395 0 1.61-.06 3.09-.18 4.439-.11 1.22-1.086 2.182-2.356 2.275Z",
      clipRule: "evenodd"
    }
  ), /* @__PURE__ */ React.createElement("circle", { cx: 20, cy: 4, r: 3.5, stroke: "currentColor" }))
);
var SvgMessageUnreadOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MessageUnreadOutlined_default = SvgMessageUnreadOutlined;

export { MessageUnreadOutlined_default as default };
